import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
import { Badge, IconButton } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import React from 'react'

const useStyles = makeStyles()(() => ({
    iconButton: {
        color: '#fffffff2',
        padding: 4
    },
    icon: {
        fontSize: 26
    }
}))

export type NotificationIconProps = {
    count: number
    onClick: () => void
}

export default function NotificationIcon({ count, onClick }: NotificationIconProps) {
    const { classes } = useStyles()

    return (
        <IconButton className={classes.iconButton} onClick={onClick}>
            <Badge
                color="error"
                variant={count > 0 ? 'dot' : 'standard'}
                overlap="circular"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <NotificationsNoneIcon className={classes.icon} />
            </Badge>
        </IconButton>
    )
}
